import http from './http';

class NotificationsService {
  static getNotifications() {
    return http.get('/notifications');
  }

  // Add this updateNotifications method if missing
  static updateNotifications(notificationId: string) {
    return http.patch(`/notifications/${notificationId}`);
  }

  static clearAllNotifications() {
    return http.put('/notifications/clear-all');
  }
}

export default NotificationsService;
